import { useCallback } from "react";
import BackGroundService from "../../../services/background";

export const useGetSendTaskStatus = (
  onSuccess: () => void,
  onError: (e: any) => void,
  isCreateEmail: boolean
) => {
  const getStatus = useCallback(
    async (id: string) => {
      try {
        const res = await BackGroundService.getProgress(id);

        const { status, result } = res;

        if ([6, 4].includes(status)) {
          if (status === 4) {
            result.failedCount === 0
              ? onSuccess()
              : onError(
                  isCreateEmail
                    ? result
                    : {
                        response: {
                          data: {
                            title: "Sending was failed",
                          },
                        },
                      }
                );
          }

          status === 6 &&
            onError({
              response: {
                data: {
                  title: "Sending was failed",
                },
              },
            });
        } else {
          setTimeout(async () => {
            await getStatus(id);
          }, 1000);
        }
      } catch (e) {
        onError(e);
      }
    },
    [onSuccess, onError, isCreateEmail]
  );

  return { getStatus };
};
